/**
 * Tutorial guidato delle Aliquote IVA.
 *
 * Nessun preparativo: la pagina e' un elenco con un bottone per aggiungere, e il
 * tutorial non tocca gli interruttori - quelli salvano subito.
 */
const SCOPE = '[data-tour-scope="setting-vat"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createVatTourSteps() {
	return [
		{
			body: 'Le aliquote IVA usate dal gestionale: quelle che compaiono nella scheda di ogni prodotto e che finiscono nei documenti. Qui si dice quali esistono, non quale applicare - quello si sceglie prodotto per prodotto.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le aliquote IVA',
		},
		{
			body: "Una riga per aliquota, con il suo interruttore. Spegnerne una non la cancella e non tocca i prodotti che ce l'hanno gia': smette solo di essere proponibile per i prodotti nuovi. L'interruttore salva subito.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Le aliquote attive',
		},
		{
			body: "I tre puntini a inizio riga servono a rendere predefinita un'aliquota o a eliminarla. La predefinita non li ha: per cambiarla si rende predefinita un'altra.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Predefinita ed eliminazione',
		},
		{
			body: "Da qui si apre il riquadro per aggiungerne una: si scrive il valore o si sceglie tra le piu' comuni, e si decide se nasce gia' attiva. Le aliquote si aggiungono di rado: succede quando cambia la legge o quando si inizia a vendere una categoria con un'aliquota diversa.",
			key: 'add',
			placement: 'bottom',
			target: at('add'),
			title: 'Aggiungere un’aliquota',
		},
	];
}
